import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { IServerErrorResponse } from '../../../types';
import { trackMixPanel } from '../../../services/mixpanel.service';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';
import { ISupplierModel } from '../types';
import { useStore } from '../../../store';
import LiliNotification, { LiliNotificationType } from '../../../DesignSystem/LiliNotification/LiliNotification';
import { LiliToastDefaultConfig } from '../../../DesignSystem/LiliToast/LiliToast';

interface IProps {
    payload: ISupplierModel;
}

export const useCreateSupplier = (onAddressMissMatch?: () => void) => {
  const { customerId } = useStore(state => state.user);
  const { accountExternalId } = useStore(state => state.getPersonalAccount());
  const { t } = useTranslation();

  return useMutation(
    'CreateSupplier',
    async ({
      payload,
    }: IProps) => {
      if (payload.supplierId) {
        const res = await httpService.post(`${BASE_URL}/api/v2/user/${customerId}/${accountExternalId}/supplier/${payload.supplierId}/update`, { ...payload });
        return res.data;
      }
      const res = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/supplier`, { ...payload });
      return res.data;
    },
    {
      retry: 0,
      onError: (e:IServerErrorResponse) => {
        const { localizedMessage, code } = flattenServerErrorResponse(e);
        trackMixPanel('Error Occurred During Move Money Flow', {
          'Error Code': code, 'Error Message': localizedMessage, 'Screen Name': 'Supplier Form', Flow: 'Mail a Check',
        });
        if (e.response.status !== 401) {
          const isManualError = [4730, 91107].includes(e?.response?.data?.errors?.[0]?.code);
          const isAddressMissMatch = [40067].includes(e?.response?.data?.errors?.[0]?.code);
          if (isAddressMissMatch && onAddressMissMatch) {
            onAddressMissMatch();
          } else {
            toast(<LiliNotification
              undismissable
              type={LiliNotificationType.ERROR}
              text={isManualError ? t('LOGIN_ERROR_POPUP_HEADER') : localizedMessage}
              id='vendorDetailsError'
            />, { ...LiliToastDefaultConfig });
          }
        }
      },
    },
  );
};
